export class AzureStorageAccount {
    'name';
    'location';
    'resourceGroup';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "location",
            "baseName": "location",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceGroup",
            "baseName": "resourceGroup",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureStorageAccount.attributeTypeMap;
    }
    constructor() {
    }
}
